import React from "react";
import "./styles.css";
import { Spin } from "antd";

function LoadingScreen() {
  return (
    <div className="loading_screen">
      <Spin spinning={true} style={{ fontSize: 50, marginBottom: 20 }} />
      <img
        src={require("../../../images/logos/logo-3.webp")}
        alt="Yeva Nails 5"
        className="header-logo"
      />
    </div>
  );
}

export default LoadingScreen;
